<ng-container [formGroup]="formGroup">
  <ng-container [formArrayName]="arrayControlName">
    @for (
      financialSectorApplicationFormGroup of getFormArray()?.controls;
      track i;
      let i = $index
    ) {
      <section [formGroupName]="i">
        @let formGroupAlertShouldBeVisible = submitted && !isFormGroupValid(i);
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              formGroupAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div
              class="card-header card-header-color-from-db d-flex justify-content-between"
            >
              {{
                'MONUMENT_CONSERVATION_GRANT_REQUEST.FINANCIAL_SECTOR_APPLICATION.TITLE'
                  | translate
              }}
              #{{ i + 1 }}
              <div>
                <button
                  (click)="deleteFormControl(i)"
                  type="button"
                  title="minus"
                  class="btn btn-danger btn-sm py-0 text-nowrap"
                >
                  <i class="fa fa-times me-2"></i>
                  <strong>{{ 'REMOVE' | translate }}</strong>
                </button>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-lg col-md-12">
                  <label
                    class="mb-0"
                    [attr.for]="financialSectorApplicationControlName.Unit"
                  >
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.FINANCIAL_SECTOR_APPLICATION.UNIT'
                        | translate
                    }}
                  </label>

                  <input
                    type="text"
                    [name]="financialSectorApplicationControlName.Unit"
                    [id]="financialSectorApplicationControlName.Unit"
                    class="form-control form-control-sm required"
                    [formControlName]="
                      financialSectorApplicationControlName.Unit
                    "
                  />
                </div>
                <div class="col-lg col-md-12">
                  <label
                    class="mb-0"
                    [attr.for]="settlementScopeControlName.Scope"
                  >
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.SCOPE' | translate
                    }}
                  </label>

                  <input
                    type="text"
                    [name]="settlementScopeControlName.Scope"
                    [id]="settlementScopeControlName.Scope"
                    class="form-control form-control-sm required"
                    [formControlName]="settlementScopeControlName.Scope"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg col-md-12">
                  <label
                    class="mb-0"
                    [attr.for]="settlementScopeControlName.Amount"
                  >
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.AMOUNT' | translate
                    }}
                  </label>

                  <input
                    type="number"
                    [name]="settlementScopeControlName.Amount"
                    [id]="settlementScopeControlName.Amount"
                    class="form-control form-control-sm required"
                    [formControlName]="settlementScopeControlName.Amount"
                    (keypress)="validateFloatInput($event)"
                  />
                </div>
                <div class="col-lg col-md-12">
                  <label
                    class="mb-0"
                    [attr.for]="settlementScopeControlName.PercentageShare"
                  >
                    {{
                      'MONUMENT_CONSERVATION_GRANT_REQUEST.PERCENTAGE_SHARE'
                        | translate
                    }}
                  </label>

                  <div class="input-group input-group-sm">
                    <input
                      type="text"
                      [name]="settlementScopeControlName.PercentageShare"
                      [id]="settlementScopeControlName.PercentageShare"
                      class="form-control required"
                      [formControlName]="
                        settlementScopeControlName.PercentageShare
                      "
                      (keypress)="validateFloatInput($event)"
                    />
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </div>

            @if (formGroupAlertShouldBeVisible) {
              <div class="card-footer">
                <div class="alert alert-danger my-2">
                  {{ 'FIELDS_REQUIRED' | translate }}
                </div>
              </div>
            }
          </div>
        </section>
      </section>
    }
  </ng-container>

  <section>
    <div class="card card-border-color-from-db mb-4">
      <div class="card-header card-header-color-from-db">
        {{
          'MONUMENT_CONSERVATION_GRANT_REQUEST.FINANCIAL_SECTOR_APPLICATION.TITLE'
            | translate
        }}
      </div>

      <div class="card-body d-grid">
        <button
          (click)="addFormControl()"
          type="button"
          title="plus"
          class="btn btn-lg btn-outline-dark fa fa-plus"
        ></button>
      </div>
    </div>
  </section>
</ng-container>
